import { SIGN_IN_FAIL, SIGN_IN_START, SIGN_IN_SUCCESS, SET_REDIRECT, ClEAR_ERROR } from './types';

const initialState = {
	displayName: '',
	email: '',
	phoneNumber: '',
	photoURL: '',
	uid: '',
	userType: '',
	loading: false,
	error: '',
	redirect: false
};

export default function (state = initialState, action) {
	const { type, payload } = action;
	switch (type) {
		case SIGN_IN_START:
			return {
				...state,
				loading: true,
				error: '',
				redirect: false
			};
		case SIGN_IN_FAIL:
			return {
				...state,
				error: payload.message,
				loading: false,
			};
		case SIGN_IN_SUCCESS:
			console.log("SIGN_IN_SUCCESS payload", payload)
			return {
				...state,
				displayName: payload.userInfo.displayName,
				email: payload.userInfo.email,
				phoneNumber: payload.userInfo.phoneNumber,
				photoURL: payload.userInfo.photoURL,
				uid: payload.userInfo.uid,
				userType: payload.userType,
				loading: false,
				redirect: true,
				error: ''
			};
		case SET_REDIRECT:
			return {
				...state,
				redirect: payload
			};
		case ClEAR_ERROR:
			return {
				...state,
				error: ''
			}
		default:
			return state;
	}
}
